module.exports = __webpack_public_path__ + "static/credit-decision-1cac37bf50edb8f2c4b68cbe2ae9d7cb.pdf";